import React from 'react'
import { Skeleton, Stack, Typography } from '@mui/material'
import sxs from './FullScreenActionDialogHeader.sxs'
import FullScreenActionDialogButtons from './FullScreenActionDialogButtons'
import { useFullScreenActionDialogContext } from './context/FullScreenActionDialogContext'
import { FullScreenActionDialogHeaderProps } from './_props'

const FullScreenActionDialogHeader: React.FC<FullScreenActionDialogHeaderProps> = ({
    title,
    innerContainerVariant = 'contained',
}) => {
    const {
        state: { isLoading },
    } = useFullScreenActionDialogContext()

    if (isLoading) {
        return (
            <Stack
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                gap="3rem"
                sx={[sxs.fullScreenActionDialogHeader, innerContainerVariant === 'fullscreen' && { boxShadow: 'none' }]}
            >
                <Skeleton variant="text" sx={sxs.fullScreenActionDialogHeaderTitleSkeleton} />
                <FullScreenActionDialogButtons />
            </Stack>
        )
    }

    return (
        <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            gap="3rem"
            sx={[sxs.fullScreenActionDialogHeader, innerContainerVariant === 'fullscreen' && { boxShadow: 'none ' }]}
        >
            <Typography sx={sxs.fullScreenActionDialogHeaderTitle}>{title}</Typography>
            <FullScreenActionDialogButtons />
        </Stack>
    )
}

export default FullScreenActionDialogHeader
